/**
 *
 * Module:        Component
 * Name:          Guru Chat Item Menu
 * Description:   Renders rename, pin and delete actions for one Guru chat
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

import React, {useState} from 'react';
import {
	IconButton,
	Menu
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import QeeTooltip from '../qeeTooltip';
import GuruChatActionMenuItems from './GuruChatActionMenuItems';

export default function GuruChatItemMenu({chat, labels, disabled, onRename, onTogglePin, onDelete}) {
	const [anchor, setAnchor] = useState(null);
	return (
		<>
			<QeeTooltip title={anchor ? '' : labels.chatActions}>
				<span>
					<IconButton
						size="small"
						disabled={disabled}
						aria-label={labels.chatActions}
						onClick={event => {
							event.stopPropagation();
							setAnchor(event.currentTarget);
						}}
						sx={{opacity: anchor ? 1 : 0.58, '&:hover': {opacity: 1}}}
					>
						<MoreHorizIcon fontSize="small" />
					</IconButton>
				</span>
			</QeeTooltip>
			<Menu
				anchorEl={anchor}
				open={Boolean(anchor)}
				onClose={() => setAnchor(null)}
				onClick={event => event.stopPropagation()}
				anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
				transformOrigin={{vertical: 'top', horizontal: 'right'}}
				PaperProps={{sx: {minWidth: 205, borderRadius: 2}}}
			>
				<GuruChatActionMenuItems
					chat={chat}
					labels={labels}
					disabled={disabled}
					onRename={onRename}
					onTogglePin={onTogglePin}
					onDelete={onDelete}
					onAction={() => setAnchor(null)}
				/>
			</Menu>
		</>
	);
}
